import { NgModule } from '@angular/core';
import { PrismaticBurstBackgroundComponent } from './prismatic-burst-background.component';
import { CommonModule } from '@angular/common';

@NgModule({
    declarations: [
        PrismaticBurstBackgroundComponent
    ],
    imports: [
        CommonModule
    ],
    exports: [
        PrismaticBurstBackgroundComponent
    ]
})
export class NcPrismaticBurstBackgroundModule { }